import { createSlice } from "@reduxjs/toolkit";
import { TemplateAnnotation } from "../types/template.types";

export type TemplateAnnotationsState = {
  annotations: TemplateAnnotation[];
  selectedAnnotationUuid: string | null;
  dropdown: { value: string }[];
};

const initialState: TemplateAnnotationsState = {
  annotations: [],
  selectedAnnotationUuid: null,
  dropdown: [],
};

export const templateAnnotationsSlice = createSlice({
  name: "templateAnnotations",
  initialState,
  reducers: {
    addAnnotation: (state, action) => {
      state.annotations.push(action.payload);
    },
    addDropdownValues: (state, action) => {
      state.dropdown = action.payload;
    },
    addOrUpdateAnnotation: (state, action) => {
      const incomingAnnotation = action.payload;

      const existingIndex = state.annotations.findIndex(
        (annotation) => annotation.uuid === incomingAnnotation.uuid
      );

      if (existingIndex !== -1) {
        state.annotations[existingIndex] = incomingAnnotation;
      } else {
        state.annotations.push(incomingAnnotation);
      }
    },
    addOrUpdateAnnotations: (
      state,
      action: { payload: TemplateAnnotation[] }
    ) => {
      const incomingAnnotations = action.payload;
      if (!incomingAnnotations) {
        return;
      }
      incomingAnnotations.forEach((newAnnotation) => {
        const existingIndex = state.annotations.findIndex(
          (annotation) => annotation.uuid === newAnnotation.uuid
        );

        if (existingIndex !== -1) {
          state.annotations[existingIndex] = newAnnotation;
        } else {
          state.annotations.push(newAnnotation);
        }
      });
    },
    deleteAnnotation: (state, action) => {
      const index = state.annotations.findIndex(
        (a) => a.uuid === action.payload
      );
      if (index !== -1) {
        state.annotations.splice(index, 1);
      }
    },
    deleteSelectedAnnotation: (state) => {
      const index = state.annotations.findIndex(
        (a) => a.uuid === state.selectedAnnotationUuid
      );
      if (index !== -1) {
        state.annotations.splice(index, 1);
      }
      state.selectedAnnotationUuid = null;
    },
    resetTemplateAnnotationsState: (state) => {
      state.annotations = [];
      state.selectedAnnotationUuid = null;
    },
    selectAnnotation: (state, action) => {
      state.selectedAnnotationUuid = action.payload;
    },
    resetDropdownValues: (state) => {
      state.dropdown = [];
    },
    moveAnnotation: (state, action) => {
      const { uuid, x, y, width, height } = action.payload;
      const index = state.annotations.findIndex((a) => a.uuid === uuid);
      if (index !== -1) {
        state.annotations[index] = {
          ...state.annotations[index],
          x,
          y,
          width,
          height,
        };
      }
    },
  },
});

export const {
  addAnnotation,
  addDropdownValues,
  addOrUpdateAnnotation,
  addOrUpdateAnnotations,
  deleteAnnotation,
  deleteSelectedAnnotation,
  resetDropdownValues,
  resetTemplateAnnotationsState,
  selectAnnotation,
  moveAnnotation,
} = templateAnnotationsSlice.actions;

export default templateAnnotationsSlice.reducer;
